// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DNwEM","image":"styles_image__EizcN","loader":"styles_loader__p-iOe","loading":"styles_loading__MyOFG"};